import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

// Public Pages
import HomePage from '@/pages/public/HomePage';
import MapViewPage from '@/pages/public/MapViewPage';
import ReportPage from '@/pages/public/ReportPage';
import PrivacyPolicy from '@/pages/public/PrivacyPolicy';

// Auth Pages
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';

// Admin Pages
import AdminDashboard from '@/pages/admin/AdminDashboard';
import MarkersList from '@/pages/admin/MarkersList';
import MarkerDetail from '@/pages/admin/MarkerDetail';
import MarkerForm from '@/pages/admin/MarkerForm';
import { UserManagement } from '@/pages/admin/UserManagement';

// User Pages
import MyReports from '@/pages/user/MyReports';
import EditReportPage from '@/pages/user/EditReportPage';

// Components
import ProtectedRoute from '@/components/auth/ProtectedRoute';

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/map" element={<MapViewPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/report" element={
        <ProtectedRoute>
          <ReportPage />
        </ProtectedRoute>
      } />

      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* User Routes */}
      <Route path="/my-reports" element={
        <ProtectedRoute>
          <MyReports />
        </ProtectedRoute>
      } />
      <Route path="/my-reports/edit/:markerId/:reportId" element={
        <ProtectedRoute>
          <EditReportPage />
        </ProtectedRoute>
      } />

      {/* Admin Routes */}
      <Route path="/admin" element={
        <ProtectedRoute requiredRole="admin">
          <Navigate to="/admin/dashboard" replace />
        </ProtectedRoute>
      } />

      <Route path="/admin/dashboard" element={
        <ProtectedRoute requiredRole="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />

      <Route path="/admin/markers" element={
        <ProtectedRoute requiredRole="admin">
          <MarkersList />
        </ProtectedRoute>
      } />

      <Route path="/admin/markers/new" element={
        <ProtectedRoute requiredRole="admin">
          <MarkerForm />
        </ProtectedRoute>
      } />

      <Route path="/admin/markers/edit/:id" element={
        <ProtectedRoute requiredRole="admin">
          <MarkerForm />
        </ProtectedRoute>
      } />

      <Route path="/admin/markers/:id" element={
        <ProtectedRoute requiredRole="admin">
          <MarkerDetail />
        </ProtectedRoute>
      } />

      <Route path="/admin/users" element={
        <ProtectedRoute requiredRole="admin">
          <UserManagement />
        </ProtectedRoute>
      } />

      {/* Redirect unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;